/**
 * @generated SignedSource<<d5acc721d520469352eff3107044d055>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TwoFactorConfigureRefetchNewTotpConfigQuery$variables = {
  id: string;
};
export type TwoFactorConfigureRefetchNewTotpConfigQuery$data = {
  readonly viewer: {
    readonly totp: {
      readonly id: string;
      readonly recoveryCodes: {
        readonly " $fragmentSpreads": FragmentRefs<"TwoFactorConfigureRecoveryCodes_recoveryCodes">;
      };
    } | null;
  } | null;
};
export type TwoFactorConfigureRefetchNewTotpConfigQuery = {
  response: TwoFactorConfigureRefetchNewTotpConfigQuery$data;
  variables: TwoFactorConfigureRefetchNewTotpConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TwoFactorConfigureRefetchNewTotpConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "TOTP",
            "kind": "LinkedField",
            "name": "totp",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RecoveryCodeBatch",
                "kind": "LinkedField",
                "name": "recoveryCodes",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TwoFactorConfigureRecoveryCodes_recoveryCodes"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TwoFactorConfigureRefetchNewTotpConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "TOTP",
            "kind": "LinkedField",
            "name": "totp",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RecoveryCodeBatch",
                "kind": "LinkedField",
                "name": "recoveryCodes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecoveryCode",
                    "kind": "LinkedField",
                    "name": "codes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "consumed",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ae81398aaa6d90163fd67f4e339fff45",
    "id": null,
    "metadata": {},
    "name": "TwoFactorConfigureRefetchNewTotpConfigQuery",
    "operationKind": "query",
    "text": "query TwoFactorConfigureRefetchNewTotpConfigQuery(\n  $id: ID!\n) {\n  viewer {\n    totp(id: $id) {\n      id\n      recoveryCodes {\n        ...TwoFactorConfigureRecoveryCodes_recoveryCodes\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment RecoveryCodeList_recoveryCodes on RecoveryCodeBatch {\n  codes {\n    code\n    consumed\n  }\n}\n\nfragment TwoFactorConfigureRecoveryCodes_recoveryCodes on RecoveryCodeBatch {\n  ...RecoveryCodeList_recoveryCodes\n  codes {\n    code\n    consumed\n  }\n}\n"
  }
};
})();

(node as any).hash = "aca3494b8d90728e560a5235cab1b7db";

export default node;
